import { IPhotoDetails } from '@/app/models/photo'
import { formatDateHourLocale, formatDateLocale } from '@/app/utils/commonFunctions'
import { LuxIcon } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { statusIconMap } from '@/app/models/photo.status'
import './PhotoDetails.scss'

export interface PhotoDetailsProps {
    details: IPhotoDetails
    goToReferenceTask: (id: string, storeId: string) => void
}

const PhotoDetails = ({ details, goToReferenceTask }: PhotoDetailsProps) => {
    const componentClass = 'smart-modals-photo-details'

    const intl = useIntl()

    return (
        <div className={componentClass}>
            <div className="sidebar-title">
                {intl.formatMessage({
                    id: 'modals.gallery.detail.save_picture.sidebar.title',
                    defaultMessage: 'Information',
                })}
            </div>
            {details.status && <div className="status">
                <LuxIcon
                    icon={statusIconMap[details.status].icon}
                    color={statusIconMap[details.status].color}
                    size={16}
                />
                <div>
                    {intl.formatMessage({
                        id: `gallery.detail.task_photo.status.${details.status}`,
                        defaultMessage: details.status,
                    })}
                </div>
            </div>}
            {details.project && (
                <>
                    <div className="title">
                        <h3>
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.reference.task',
                                defaultMessage: 'Reference Task',
                            })}
                        </h3>
                    </div>
                    <div className="label-value">
                        <div className="text">{details.project.title}</div>
                    </div>
                    <div className="label-value">
                        <div
                            className="value link-mini"
                            onClick={() => goToReferenceTask(details.project.id, details.store.storeId)}>
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.reference.go.to.task',
                                defaultMessage: 'Go to reference task',
                            })}
                        </div>
                    </div>
                </>
            )}
            <div className="title">
                <h3>
                    {intl.formatMessage({
                        id: 'modals.task.photo.details.reference.store',
                        defaultMessage: 'Reference Store',
                    })}
                </h3>
            </div>
            {[
                'storeName',
                'storeId',
                'address',
                'banner',
                'macroregion',
                'country',
                'marketingSegment',
            ].map((field) => (
                <div className="label-value">
                    <div className="label">
                        {intl.formatMessage({
                            id: `modals.task.photo.details.store.${field}`,
                            defaultMessage: field,
                        })}
                    </div>
                    <div className="value text">{details.store[field]}</div>
                </div>
            ))}
            <div className="label-value">
                <div className="label">
                    {intl.formatMessage({
                        id: 'ph2.modals.task.photo.details.fixture.count',
                        defaultMessage: 'Fixture Count',
                    })}
                </div>
                <div className="value text">{details.fixtureCount}</div>
            </div>
            <div className="label-value">
                <div className="label">
                    {intl.formatMessage({
                        id: 'ph2.modals.task.photo.details.marco.area',
                        defaultMessage: 'Macro Area',
                    })}
                </div>
                <div className="value text">{details.macroarea}</div>
            </div>
            {details.project && (
                <>
                    <div className="title">
                        <h3>
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.reference.project',
                                defaultMessage: 'Reference Project',
                            })}
                        </h3>
                    </div>
                    <div className="label-value">
                        <div className="label">
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.project.type',
                                defaultMessage: 'Project Type',
                            })}
                        </div>
                        <div className="value text">{details.project.type}</div>
                    </div>
                    <div className="label-value">
                        <div className="label">
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.project.name',
                                defaultMessage: 'Project Name',
                            })}
                        </div>
                        <div className="value text">{details.project.title}</div>
                    </div>
                    <div className="label-value">
                        <div className="label">
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.project.id',
                                defaultMessage: 'Project ID',
                            })}
                        </div>
                        <div className="value text">{details.project.id}</div>
                    </div>
                    <div className="label-value">
                        <div className="label">
                            {intl.formatMessage({
                                id: 'modals.task.photo.details.project.last.published.period',
                                defaultMessage: 'Last Published Period',
                            })}
                        </div>
                        {details.publishedUserData && (
                            <div className="value text">
                                {formatDateLocale(
                                    new Date(details.publishedUserData.data).toLocaleDateString()
                                )}{' '}
                                {formatDateHourLocale(new Date().toUTCString())}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}

export default PhotoDetails
